var map = {
	"./ADA.svg": 623,
	"./BCH.svg": 624,
	"./BNB.svg": 625,
	"./BTC.svg": 626,
	"./CHZ.svg": 627,
	"./DASH.svg": 628,
	"./DOGE.svg": 629,
	"./DOT.svg": 630,
	"./ETC.svg": 631,
	"./ETH.svg": 632,
	"./EUR.svg": 633,
	"./GBP.svg": 634,
	"./LINK.svg": 635,
	"./LTC.svg": 636,
	"./MATIC.svg": 637,
	"./MKR.svg": 638,
	"./SHIB.svg": 639,
	"./SOL.svg": 640,
	"./TRX.svg": 641,
	"./UNI.svg": 642,
	"./USD.svg": 643,
	"./USDT.svg": 644,
	"./XLM.svg": 645,
	"./XMR.svg": 646,
	"./XRP.svg": 647,
	"./documents.svg": 648
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 622;